import { useEffect, useState } from 'react';

import { FormControlLabel, Switch } from '@mui/material';
import { useFormikContext } from 'formik';

import { Revendedor } from 'pages/revendedor/revendedor/types';

export function RevendedorAtivoToggle() {
    const { values, setFieldValue } = useFormikContext<Revendedor>();
    const [switchChecked, setSwitchChecked] = useState<boolean>(true);

    const handleChangeStatus = (fgAtivo: boolean): void => {
        setSwitchChecked(fgAtivo);
        setFieldValue('fgAtivo', fgAtivo);
    };

    useEffect(() => {
        if (values.fgAtivo !== switchChecked) {
            handleChangeStatus(Boolean(values.fgAtivo));
        }
    }, [values.fgAtivo]);

    return <FormControlLabel control={<Switch checked={switchChecked} onChange={(e, checked) => handleChangeStatus(checked)} />} label="Ativo" />;
}
